var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WidgetCard',{staticClass:"flex-grow-1",attrs:{"heading":_vm.title}},[_c('WidgetDoughnut',{attrs:{"chart-data":_vm.data.chartData,"currency":_vm.eventCurrency,"legend-items":_vm.data.legendItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }